import { type ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router';
import { ROUTES } from 'constants/routes';
import { useUserStore } from 'stores/user';
import { getRefreshToken } from 'utils/storage';

export const ProtectedRoute = ({ allowedRoles }: { allowedRoles: string[] }): ReactNode => {
  const refreshToken = getRefreshToken();
  const user = useUserStore(state => state.user);

  if (!refreshToken) {
    return <Navigate to={ROUTES.LOGIN} />;
  }

  if (location.pathname === ROUTES.ROOT) {
    return <Navigate to={ROUTES.HOME} />;
  }

  if (user?.requiredProfileSetup && location.pathname !== ROUTES.PROFILE_SETUP) {
    return <Navigate to={ROUTES.PROFILE_SETUP} />;
  }

  if (user && !allowedRoles.includes(user.type)) {
    return <Navigate to={ROUTES.HOME} />;
  }

  return <Outlet />;
};
